// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"1967c19c","563":"a2d48f56","740":"489366c7"}[chunkId] + ".chunk.css";
};